/**
 * Saklar fitur yang dinilai saat BUILD.
 *
 * Vue CLI menanam `process.env.VUE_APP_*` ke dalam bundel, jadi saklar di sini
 * tidak bisa diubah saat aplikasi sudah jalan — mengubahnya berarti build ulang.
 * Itu disengaja: yang dibutuhkan adalah memisahkan lingkungan (QA boleh, produksi
 * belum), bukan mematikan fitur di tengah sesi pemakai.
 */

/** Terima beberapa ejaan supaya `.env` yang ditulis tangan tidak gagal diam-diam. */
function menyala(nilai) {
  return ["1", "true", "buka", "on", "ya"].includes(String(nilai || "").trim().toLowerCase());
}

/**
 * Boleh membuat permohonan kuitansi resmi BARU?
 *
 * TERTUTUP SECARA BAWAAN, dan itu bukan kelalaian. Lingkungan yang lupa menyetel
 * variabelnya akan menyembunyikan fitur — bukan menawarkannya ke pasien sungguhan
 * sebelum lolos UAT. Membuka butuh tindakan sadar; menutup tidak butuh apa-apa.
 *
 * Yang dimatikan HANYA pengajuan baru. Permohonan yang sudah telanjur ada tetap
 * bisa dibuka, dilacak, dan dibayar — mematikannya berarti pasien yang sudah
 * membayar kehilangan satu-satunya layar yang memberitahu lembarnya ada di mana.
 *
 * Dibuka dengan `VUE_APP_KUITANSI_PENGAJUAN=buka` di `.env`.
 */
export const PENGAJUAN_KUITANSI_DIBUKA = menyala(process.env.VUE_APP_KUITANSI_PENGAJUAN);

export default { PENGAJUAN_KUITANSI_DIBUKA };
